import { useEffect } from "react";
import { Formik, FormikDataEntryValues } from "src/types/formik";
import { FormikMainInsuredGroup } from "src/types/formik/group.types";
import { useBoolean } from "src/utils";

export const useScrollToError = ({ errors }: Formik<FormikDataEntryValues>) => {
  const [toCheck, startCheck, stopCheck] = useBoolean();

  useEffect(() => {
    if (toCheck) {
      stopCheck();
      const err = Object.keys(errors)[0];
      let error = err;
      if (err === "insured_list") {
        const fields: Record<string, string>[] = errors?.insured_list as any;

        const filteredFields = fields?.filter((field) => field !== undefined);
        const filteredFieldsIndex = fields?.findIndex(
          (field) => field !== undefined
        );

        const firstError = Object.keys(filteredFields[0] || {})[0];
        error = "insured_list." + filteredFieldsIndex + "." + firstError;
      }
      if (error) {
        if (error === "coverage_radios") {
          window.scroll(0, 0);
        }
        document?.getElementById("input-" + error)?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors, toCheck]);

  const triggerFormikCheck = startCheck;

  return { triggerFormikCheck };
};

export const useScrollToErrorGroup = ({ errors }: Formik<FormikMainInsuredGroup>) => {
  const [toCheck, startCheck, stopCheck] = useBoolean()

  useEffect(() => {
    if (toCheck) {
      stopCheck()
      const err = Object.keys(errors)[0]
      let error = err
      if (error) {
        if (error === 'insured_days') {
          window.scroll(0, 0)
        }
        if (error === 'mainInsured') {
          const mainInsuredErrors = Object.values(errors)[0]
          const mainInsuredErr = Object.keys(mainInsuredErrors)[0]
          error = `${error}.${mainInsuredErr}`
        }
        document?.getElementById(`input-${error}`)?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      }
    }
  }, [errors, toCheck, stopCheck])

  const triggerFormikCheck = startCheck

  return { triggerFormikCheck }
};
